import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const AdKernelHourlyTable = ({ report, total, quality,  onSortChange }) => {
    const rows = report.map((row, index) => (<Row row={row} quality={quality} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} quality={quality} />
            <tbody>
                <TotalRow data={total} quality={quality}/>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdKernelHourlyTable;


// WEBPACK FOOTER //
// ./src/scenes/AdKernelHourly/components/Table/index.js